import { inject, NgModule, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { appRoutes } from './app.routes';
import { AppConfigMap } from '@sko/iso';
import { Amplify } from 'aws-amplify';
import { HomepageComponent } from './homepage/homepage.component';
import { SignInComponent } from './sign-in/sign-in.component';
import { SignOutComponent } from './sign-out/sign-out.component';
import { NotAllowedComponent } from './not-allowed/not-allowed.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MakeCallComponent } from './make-call/make-call.component';
import { SendMessageComponent } from './send-message/send-message.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectPhoneNumberComponent } from './select-phone-number/select-phone-number.component';
import { SelectPhoneNumberDialogComponent } from './select-phone-number-dialog/select-phone-number-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TextFieldModule } from '@angular/cdk/text-field';
import { LoggerService } from '@digitaltoolbuilders/ng-logging';

@NgModule({
  declarations: [
    AppComponent,
    HomepageComponent,
    SignInComponent,
    SignOutComponent,
    NotAllowedComponent,
    MakeCallComponent,
    SendMessageComponent,
    SelectPhoneNumberComponent,
    SelectPhoneNumberDialogComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatSlideToggleModule,
    ReactiveFormsModule,
    RouterModule.forRoot(appRoutes),
    TextFieldModule,
  ],
  providers: [
    provideAppInitializer(() => {
        const initializerFn = (() => {

        const logger = inject(LoggerService);

        return () => {

          return fetch('/app-config-map.json')
            .then((response) => {
              return response.json();
            })
            .then((configMap: AppConfigMap) => {
              const config = configMap.regionalConfigs[configMap.defaultRegion];

              console.log('Amplify.configure', config);

              Amplify.configure(config.amplify);

              logger.info({ config: Amplify.getConfig() }, 'after configure');
            })
            .catch((e) => {
              logger.error(e);

              throw e;
            });
        };
      })();
        return initializerFn();
      }),
    provideAnimationsAsync(),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
